import React from 'react';
import { Box, IconButton } from '@mui/material';

type PropTypes = {
  numberOfImages: number;
  handleSelectSlide: any;
  currentIndex: number;
};

export default function CardHistoryIndicator(props: PropTypes) {
  const { numberOfImages, handleSelectSlide, currentIndex } = props;

  const range = Array.from({ length: numberOfImages }, (_, index) => index);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        my: 2,
      }}
    >
      {range.map((index) => (
        <IconButton
          key={index}
          onClick={() => handleSelectSlide(index)}
          sx={{
            cursor: 'pointer',
            width: 10,
            height: 10,
            borderRadius: '50%',
            margin: '0 5px',
            backgroundColor: index === currentIndex ? '#444' : 'gray',
            '&:hover': {
              backgroundColor: index === currentIndex ? '#555' : '#777',
            },
          }}
        />
      ))}
    </Box>
  );
}
